import { Component, Input } from '@angular/core';

export enum SpinnerSizes {
  EXTRA_SMALL = 'extra-small',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

@Component({
  moduleId: module.id,
  selector: 'spinner',
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent {
  @Input() color: string = 'blue';
  @Input() size: SpinnerSizes | string = SpinnerSizes.LARGE;
}
